"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataTable = _interopRequireDefault(require("./DataTable"));

var _MobileView = _interopRequireDefault(require("../../../elements/view/MobileView"));

var _TabletView = _interopRequireDefault(require("../../../elements/view/TabletView"));

var _DesktopView = _interopRequireDefault(require("../../../elements/view/DesktopView"));

var _DesktopTabletView = _interopRequireDefault(require("../../../elements/view/DesktopTabletView"));

var _TabletCellFormatter = _interopRequireDefault(require("./Formatters/TabletCellFormatter"));

var _MobileAccordions = _interopRequireDefault(require("../../accordion/MobileAccordions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function buildTabletColumns(tabletColumns) {
  var cols = [];
  tabletColumns.forEach(function (tabletCol) {
    var col = {
      name: tabletCol.name,
      key: tabletCol.primaryKey,
      width: tabletCol.width,

      /* eslint-disable */
      formatter: function formatter(props) {
        return _react["default"].createElement(_TabletCellFormatter["default"], _extends({}, props, {
          secondaryKey: tabletCol.secondaryKey,
          primaryFormatter: tabletCol.primaryFormatter,
          secondaryFormatter: tabletCol.secondaryFormatter
        }));
      },

      /* eslint-enable */
      getRowMetaData: function getRowMetaData(row) {
        return row;
      }
    };

    if (tabletCol.sortable !== undefined) {
      col.sortable = tabletCol.sortable;
    }

    if (tabletCol.locked !== undefined) {
      col.locked = tabletCol.locked;
    }

    cols.push(col);
  });
  return cols;
}

var AccordionTableWrapper = function AccordionTableWrapper(_ref) {
  var data = _ref.data,
      columns = _ref.columns,
      height = _ref.height,
      sortFunc = _ref.sortFunc,
      sortColumn = _ref.sortColumn,
      sortDirection = _ref.sortDirection,
      minColumnWidth = _ref.minColumnWidth,
      headerRowHeight = _ref.headerRowHeight,
      tabletColumns = _ref.tabletColumns,
      rowSelection = _ref.rowSelection,
      rowRenderer = _ref.rowRenderer,
      hasTotals = _ref.hasTotals,
      accordion = _ref.accordion,
      rest = _objectWithoutProperties(_ref, ["data", "columns", "height", "sortFunc", "sortColumn", "sortDirection", "minColumnWidth", "headerRowHeight", "tabletColumns", "rowSelection", "rowRenderer", "hasTotals", "accordion"]);

  if (tabletColumns !== undefined) {
    tabletColumns = buildTabletColumns(tabletColumns);
  }

  var mobileData = data;

  if (hasTotals) {
    mobileData.splice(-1, 1);
  }

  return _react["default"].createElement("div", {
    id: "accordion-table-wrapper"
  }, _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(_MobileAccordions["default"], {
    data: mobileData,
    holderHeight: height + 300,
    accordion: accordion
  })), tabletColumns && tabletColumns.length ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_TabletView["default"], null, _react["default"].createElement(_DataTable["default"], _extends({
    data: data,
    columns: tabletColumns,
    height: height,
    sortFunc: sortFunc,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    minColumnWidth: minColumnWidth,
    rowSelection: rowSelection,
    headerRowHeight: headerRowHeight,
    rowHeight: 50,
    rowRenderer: rowRenderer,
    hasTotals: hasTotals
  }, rest))), _react["default"].createElement(_DesktopView["default"], null, _react["default"].createElement(_DataTable["default"], _extends({
    data: data,
    columns: columns,
    height: height,
    sortFunc: sortFunc,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    minColumnWidth: minColumnWidth,
    headerRowHeight: headerRowHeight,
    rowSelection: rowSelection,
    rowRenderer: rowRenderer,
    hasTotals: hasTotals
  }, rest)))) : _react["default"].createElement(_DesktopTabletView["default"], null, _react["default"].createElement(_DataTable["default"], _extends({
    data: data,
    columns: columns,
    height: height,
    sortFunc: sortFunc,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    minColumnWidth: minColumnWidth,
    headerRowHeight: headerRowHeight,
    rowSelection: rowSelection,
    rowRenderer: rowRenderer,
    hasTotals: hasTotals
  }, rest))));
};

AccordionTableWrapper.propTypes = {
  /** Data to be displayed in the table/accordion */
  data: _propTypes["default"].array.isRequired,

  /** See column definition of Data Table */
  columns: _propTypes["default"].array.isRequired,

  /** Columns to display differently on a tablet.  If these are not present it will only change on a mobile device */
  tabletColumns: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    primaryKey: _propTypes["default"].string,
    secondaryKey: _propTypes["default"].string,
    width: _propTypes["default"].number,
    primaryFormatter: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object]),
    secondaryFormatter: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object]),
    sortable: _propTypes["default"].bool,
    locked: _propTypes["default"].bool
  })),

  /** Height of the table/accordion scroll area */
  height: _propTypes["default"].number,

  /** The accordion component in which data will be passed to for each value in your data when on a mobile view */
  accordion: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].node, _propTypes["default"].object]).isRequired,

  /** Min column width of the data table */
  minColumnWidth: _propTypes["default"].number,

  /** See row selection of data table */
  rowSelection: _propTypes["default"].object,

  /** Function passed back with the column and direction to sort your data */
  sortFunc: _propTypes["default"].func,

  /** The column that is currently sorted */
  sortDirection: _propTypes["default"].string,

  /** The direction that the grid is currently sorted in */
  sortColumn: _propTypes["default"].string,

  /** row renderer passed to the data table */
  rowRenderer: _propTypes["default"].func,

  /** if the data baseTables has a totals row */
  hasTotals: _propTypes["default"].bool,

  /** height of the header row */
  headerRowHeight: _propTypes["default"].number
};
AccordionTableWrapper.defaultProps = {
  height: 400,
  sortFunc: function sortFunc() {},
  minColumnWidth: 100,
  headerRowHeight: 50,
  tabletView: false,
  hasTotals: false,
  rowSelection: null,
  rowRenderer: null,
  tabletColumns: [],
  sortDirection: "",
  sortColumn: ""
};
var _default = AccordionTableWrapper;
exports["default"] = _default;